<template>
    <admin-table-row :item="video">
        <td class="column-thumb">
            <div class="video-table-thumb flex items-center justify-center">
                <img
                    v-if="video.thumb"
                    :src="video.thumb"
                    :alt="(video.title || 'Video') + ' thumbnail'"
                    class="max-w-full max-h-full"
                />
                <span v-else class="text-pip-gray" aria-label="No thumbnail">—</span>
            </div>
        </td>
        <td class="column-title">
            <router-link
                class="video-title block font-semibold"
                :to="{ name: 'video-edit', params: { id: video.id } }"
            >
                {{ video.title || "Untitled video" }}
            </router-link>
            <div class="row-actions mt-1 text-xs">
                <router-link :to="{ name: 'video-edit', params: { id: video.id } }">Edit</router-link>
                <template v-if="video.src && !isEmbedded">
                    <span aria-hidden="true"> | </span>
                    <a :href="video.src" target="_blank" rel="noopener">Open video</a>
                </template>
                <span aria-hidden="true"> | </span>
                <button
                    type="button"
                    class="delete-row-action"
                    :disabled="deleting"
                    @click="$emit('delete', video)"
                >
                    {{ deleting ? "Deleting…" : "Delete" }}
                </button>
            </div>
        </td>
        <td>
            <span class="type-badge">{{ isEmbedded ? "Embed" : "File" }}</span>
        </td>
        <td class="path-cell" :title="video.src || ''">{{ video.src || "—" }}</td>
        <td class="path-cell" :title="video.thumb || ''">{{ video.thumb || "—" }}</td>
    </admin-table-row>
</template>

<script>
import { AdminTableRow } from "@c/shared/admin";

export default {
    name: "VideoAdminTableRow",
    components: { AdminTableRow },
    props: {
        video: { type: Object, required: true },
        deleting: { type: Boolean, default: false },
    },
    computed: {
        isEmbedded() {
            return [1, "1", "y", true].includes(this.video.is_embed);
        },
    },
};
</script>

<style scoped lang="scss">
td {
    padding: 0.55rem 0.65rem;
    border-top: 1px solid var(--color-gallery);
    vertical-align: middle;
}

tr:nth-child(even) { background: #f9f9f9; }
tr:hover { background: #f2f7fb; }

.column-thumb { width: 8rem; }
.column-title { width: 30%; }

.video-table-thumb {
    width: 6.5rem;
    aspect-ratio: 16 / 9;
    border: 1px solid var(--color-light-grey);
    background: #111;
    overflow: hidden;
}

.video-table-thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.video-title {
    color: #01549e;
    font-size: var(--font-size-base);
    line-height: var(--line-height-tight);
}

.row-actions { color: var(--color-pip-gray); }

.type-badge {
    display: inline-flex;
    padding: 0.15rem 0.45rem;
    border-radius: 999px;
    background: #e3e3e3;
    color: var(--color-mine-shaft);
    font-size: 0.625rem;
    font-weight: var(--font-weight-bold);
    letter-spacing: 0.03em;
    text-transform: uppercase;
}

.delete-row-action {
    display: inline;
    margin: 0;
    padding: 0;
    border: 0;
    background: transparent;
    color: #a51600;
    cursor: pointer;
    font-family: inherit !important;
    font-size: inherit;
    line-height: inherit;
    text-transform: none;
}

.delete-row-action:hover:not(:disabled) {
    background: transparent;
    color: #cd1b00;
    text-decoration: underline;
}

.delete-row-action:disabled { cursor: wait; opacity: 0.6; }

.path-cell {
    max-width: 21rem;
    overflow: hidden;
    color: var(--color-pip-gray);
    font-size: var(--font-size-xs);
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
